import { DataTableResetFilter } from '@/common/ui/table/data-table-reset-filter'
import { LineAutoMessageLogModel } from '../../types'
import { LineAutoMessageLogType } from '@/schema'
import { columns } from './constants'
import { DataTableArrow } from '@/common/ui/table/data-table-arrow'
import {
	Select,
	SelectContent,
	SelectGroup,
	SelectItem,
	SelectLabel,
	SelectTrigger,
	SelectValue,
} from '@/common/ui/select'
import { LOG_TYPE_OPTIONS } from '../../constants'

interface LineMessageLogTableProps {
	data: LineAutoMessageLogModel[]
	total: number
	isLoading?: boolean
	logTypeFilter: LineAutoMessageLogType | ''
	onLogTypeChange: (value: LineAutoMessageLogType | '') => void
}

export default function LineMessageLogTable({
	data,
	total,
	isLoading,
	logTypeFilter,
	onLogTypeChange,
}: LineMessageLogTableProps) {
	return (
		<div className="space-y-4">
			<div className="flex flex-wrap items-center gap-4">
				<Select
					value={logTypeFilter}
					onValueChange={(value) =>
						onLogTypeChange(value as LineAutoMessageLogType | '')
					}
				>
					<SelectTrigger className="w-[180px]">
						<SelectValue placeholder="เลือกประเภท" />
					</SelectTrigger>
					<SelectContent>
						<SelectGroup>
							<SelectLabel>ประเภท</SelectLabel>
							{LOG_TYPE_OPTIONS.map((option) => (
								<SelectItem key={option.value} value={option.value}>
									{option.label}
								</SelectItem>
							))}
						</SelectGroup>
					</SelectContent>
				</Select>
				<DataTableResetFilter />
			</div>
			<DataTableArrow
				columns={columns}
				data={data}
				total={total}
				isLoading={isLoading}
			/>
		</div>
	)
}
